module.exports = __webpack_public_path__ + "img/garden-placeholder.14654c46.png";